import request from "@/utils/request";

// 主页数据查询
export function home() {
  return request({
    url: "/index/home",
    method: "get",
  });
}

export function updateInviteCodeApi(params) {
  return request({
    url: '/invite/updateInviteCode',
    method: 'post',
    params
  })
}

export function exchangeLoginTicket(ticket) {
  return request({
    url: "/login/exchangeTicket",
    method: "get",
    params: { ticket },
  });
}
